<template>
    <v-overlay :model-value="loading" class="align-center justify-center" persistent>
        <v-progress-circular color="amber" indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- BENEFICIARY FORM -->
    <img src="@/assets/learning1.jpg" class="img-fluid formBanner" alt="Beneficiary Application Banner">
    <div class="container outerContainer col-md-6 isForm">
        <div class="container innerContainer">

            <p id="eventFormHeader">APPLY AS A BENEFICIARY</p>
            <form class="row g-3" novalidate>

                <!-- Full Name -->
                <div class="col-md-6">
                    
                    <label for="inputFullName" class="form-label">Full Name</label>
                    <input type="text" class="form-control" id="inputFullName" placeholder="Full Name"
                        v-model="beneficiaryFormData.fullName" @input="beneficiaryForm$.fullName.$touch">
                    <div v-if="beneficiaryForm$.fullName.$errors[0]" class="alert alert-danger m-0 p-1">
                        <em> {{ beneficiaryForm$.fullName.$errors[0].$message }}</em>
                    </div>
                </div>

                <!-- Email -->
                <div class="col-md-6">
                    <label for="inputEmailAddress" class="form-label">E-mail Address</label>
                    <input type="text" class="form-control" id="inputEmailAddress" placeholder="E-mail Address"
                        v-model="beneficiaryFormData.email" @input="beneficiaryForm$.email.$touch">
                    <div v-if="beneficiaryForm$.email.$errors[0]" class="alert alert-danger m-0 p-1">
                        <em> {{ beneficiaryForm$.email.$errors[0].$message }}</em>
                    </div>
                </div>

                <!-- Contact number -->
                <div class="col-md-6">
                    <label for="inputContactNumber" class="form-label">Contact Number</label>
                    <input type="text" class="form-control" id="inputContactNumber" placeholder="Contact Number"
                        v-model="beneficiaryFormData.contactNumber" @input="beneficiaryForm$.contactNumber.$touch">
                    <div v-if="beneficiaryForm$.contactNumber.$errors[0]" class="alert alert-danger m-0 p-1">
                        <em> {{ beneficiaryForm$.contactNumber.$errors[0].$message }}</em>
                    </div>
                </div>

                <!-- Affiliation -->
                <div class="col-md-6">
                    <label for="inputAffiliation" class="form-label">Affiliation</label>
                    <input type="text" class="form-control" id="inputAffiliation" placeholder="Affiliation"
                        v-model="beneficiaryFormData.affiliation" @input="beneficiaryForm$.affiliation.$touch">
                    <div v-if="beneficiaryForm$.affiliation.$errors[0]" class="alert alert-danger m-0 p-1">
                        <em> {{ beneficiaryForm$.affiliation.$errors[0].$message }}</em>
                    </div>
                </div>

                <!-- Story -->
                <div class="form-group">
                    <label for="beneficiaryStory">Tell us a story why you want to be a beneficiary</label>
                    <textarea class="form-control" id="beneficiaryStory" rows="3" placeholder="Type your story here"
                        v-model="beneficiaryFormData.story" @input="beneficiaryForm$.story.$touch"></textarea>
                    <div v-if="beneficiaryForm$.story.$errors[0]" class="alert alert-danger m-0 p-1">
                        <em> {{ beneficiaryForm$.story.$errors[0].$message }}</em>
                    </div>
                </div>

            </form>
        </div>
        <button type="submit" id="registerButton" @click="submitForm">Register</button>
    </div>
</template>

<script>
// Dependencies
import { reactive, ref } from 'vue';
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "@/firebase";
import useVuelidate from '@vuelidate/core';
import { required, helpers, email, maxLength } from '@vuelidate/validators';

export default {

    setup() {
        // Form data
        const beneficiaryFormData = reactive({
            fullName: "",
            email: "",
            contactNumber: "",
            affiliation: "",
            story: "",
        })

        const loading = ref(false);

        // Regex for contact number
        const validContactNumber = (contactNumber) => {
            const regex = /^[0][9][0-9]{9}$/;
            return regex.test(contactNumber);
        }


        // Vuelidate rules
        const beneficiaryFormRules = {
            fullName: { required, maxLength: maxLength(300) },
            email: { required, email, maxLength: maxLength(254) },
            contactNumber: { required, validContactNumber: helpers.withMessage("Invalid Contact Number (Example: 09123456789)", validContactNumber) },
            affiliation: { required, maxLength: maxLength(150) },
            story: { required, maxLength: maxLength(10000) },
        }

        // Vuelidate init
        const beneficiaryForm$ = useVuelidate(beneficiaryFormRules, beneficiaryFormData);


        const submitForm = async () => {

            // Validate form
            const result = await beneficiaryForm$.value.$validate();

            loading.value = true;

            if (result) {
                // Add to database
                const colRef = collection(db, "Gift Giving Applications")
                await addDoc(colRef, {
                    Name: beneficiaryFormData.fullName,
                    Email: beneficiaryFormData.email,
                    ContactNumber: beneficiaryFormData.contactNumber,
                    IsGiven: false,
                    GivenTimestamp: null,
                    CreationTimestamp: serverTimestamp(),
                    Affiliation: beneficiaryFormData.affiliation,
                    Story: beneficiaryFormData.story,
                    IsAccepted: null,
                    IsArchived: false
                })

                //Alert Registration successful
                alert("Successfully Registered!");
                //Clear form
                beneficiaryFormData.fullName = "";
                beneficiaryFormData.email = "";
                beneficiaryFormData.contactNumber = "";
                beneficiaryFormData.affiliation = "";
                beneficiaryFormData.story = "";
                //Clear errors in form
                beneficiaryForm$.value.$reset();

            } else {
                alert("Please check the form for errors")
            }

            loading.value = false;
        }

        return {
            beneficiaryFormData,
            beneficiaryForm$,
            submitForm,
            loading
        }
    },
}
</script>

<style scoped src="@/assets/css/globalStyle.css"></style>
